import React, { useEffect } from 'react';
import * as tinymceReact from '@tinymce/tinymce-react';
import * as tinymce from 'tinymce';

import { TINYMCE_EDITOR_HTML_STRING_LIMIT } from '../../utils/constants';


interface Props {
  editorValue: string,
  setEditorValue?: React.Dispatch<React.SetStateAction<string>>,
  placeholder?: string,
}

const TinymceEditor = ({ editorValue, setEditorValue, placeholder }: Props) => {
  const { Editor } = tinymceReact;
  const editorValueLength: number = editorValue ? editorValue.length : 0;

  useEffect(() => {
    // HTML element on the bottom right of the Editor
    // Default text is 'Powered by Tiny'
    // We use that space to display character limit, e.g. 150 / 200
    const bottomRightEl = document.querySelector('span.tox-statusbar__branding') as HTMLSpanElement;

    if (!bottomRightEl) {
      return;
    }

    bottomRightEl.innerHTML = `${editorValueLength} / ${TINYMCE_EDITOR_HTML_STRING_LIMIT} html characters`;

    if (editorValueLength > TINYMCE_EDITOR_HTML_STRING_LIMIT) {
      bottomRightEl.style.color = 'red';
    } else {
      bottomRightEl.style.color = 'initial';
    }
  }, [editorValueLength]);

  const initialSettings: (tinymce.RawEditorSettings & { selector?: undefined; target?: undefined; }) = {
    placeholder,
    menubar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help',
    ],
    toolbar: 'bold italic underline link | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
    // Ant Design default styles
    // content_style: "body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 14px; }",
    content_style: "body { font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; font-size: 14px; }",
  };

  const onEditorChange = (content: string, editor: tinymce.Editor) => {
    setEditorValue && setEditorValue(content);
  }

  return (
    <>
      <Editor
        init={initialSettings}
        value={editorValue}
        onEditorChange={onEditorChange}
      />
      {editorValueLength > TINYMCE_EDITOR_HTML_STRING_LIMIT &&
      <p className="sub-heading-font" style={{ textAlign: 'right', color: 'red', fontSize: '12px', marginBottom: '0' }}>
        CHARACTER LIMIT EXCEEDED: CONTENT WON'T BE SAVED
      </p>}
    </>
  );
}

export default TinymceEditor;
